import { PaginationFilter } from "@/@types/generics/genericals";
import { Paginated } from "@/@types/generics/paginated";
import { esusApi } from "@/services/api";

export type ResumeIndicatorB2ByHealthTeamParams = PaginationFilter & {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	search: string;
	ine?: string;
	export?: boolean;
};

export class ResumeIndicatorB2ByHealthTeamData {
	esbHealthTeamId: number = 0;
	esbHealthTeamIne: string = "";
	esbHealthTeamName: string = "";
	linkedHealthTeamId: number = 0;
	linkedHealthTeamIne: string = "";
	linkedHealthTeamName: string = "";
	totalCitizens: number = 0;
	totalCitizensStarted: number = 0;
	totalCitizensStartedLinked: number = 0;
	totalCitizensFinished: number = 0;
	totalCitizensFinishedLinked: number = 0;
}

export async function getResumeIndicatorB2ByHealthTeam({
	uf,
	ibgeCode,
	...params
}: ResumeIndicatorB2ByHealthTeamParams) {
	const response = await esusApi.get<Paginated<ResumeIndicatorB2ByHealthTeamData>>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esb/b2/health-teams-resume`,
		params
	);
	return response.data ?? new Paginated<ResumeIndicatorB2ByHealthTeamData>();
}
